import React, { useEffect } from 'react';

export default function Mood({ setArrowPosition }) {
    useEffect(() => {
        const arrow = document.querySelector('.arrow');
        const updateArrowPosition = () => {
            const computedStyle = getComputedStyle(arrow);
            const matrix = new WebKitCSSMatrix(computedStyle.transform);
            const angle = Math.round(Math.atan2(matrix.m21, matrix.m11) * (180 / Math.PI));
            setArrowPosition((angle + 360) % 360);
        };

        const interval = setInterval(updateArrowPosition, 100); // Adjust interval as needed

        return () => clearInterval(interval);
    }, [setArrowPosition]);

    return (
        <div className="pie-chart">
            <div className="arrow"></div>
            <img src="../../stageAssets/stage1/mood pie chart/breathingPieChart.gif" alt="Mood Pie Chart" />
        </div>
    );
}
